import { NextRouter } from 'next/router';

export const possiblyFalseyLinkHandler = (
    linkUrl: string | null | undefined,
    router: NextRouter
) => {
    linkUrl && router.push(linkUrl);
};
